function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 3v14.737H0V3h20zM1.031 4.085v12.598h.081l6.256-5.927-6.337-6.671zm10.886 7.422L10 13.527l-1.919-2.02-5.463 5.176h14.763l-5.464-5.176zm7.05-7.42l-6.336 6.669 6.257 5.927h.08l-.001-12.596zm-1.386-.036H2.417L10 12.032l7.581-7.981z",
  fill: "param(fill) #262626",
  fillRule: "nonzero"
});
function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgSend;